import { FormApi } from 'final-form';
import { times, flatten } from 'lodash';

import { RoomConfiguration } from 'store/groupDetailsSlice';

import RoomRenderer from './RoomRenderer';

import { FormValues } from './index';

interface RoomTypeSectionProps {
  roomType: 'single' | 'double' | 'suite';
  configurations?: RoomConfiguration[];
  quantity: number;
  form: FormApi<FormValues, Partial<FormValues>>;
}

const RoomTypeSection = ({
  roomType,
  configurations,
  quantity,
  form,
}: RoomTypeSectionProps) => {
  // Default guests per room type
  const getDefaultGuests = (type: string) => {
    switch (type) {
      case 'single':
        return 1;
      case 'double':
        return 2;
      case 'suite':
        return 1;
      default:
        return 1;
    }
  };

  if (configurations) {
    // Use room configurations if available
    return (
      <>
        {flatten(
          configurations.map((config, configIndex) =>
            times(config.rooms, (roomIndex) => {
              const globalIndex =
                configurations
                  .slice(0, configIndex)
                  .reduce((acc, c) => acc + c.rooms, 0) + roomIndex;

              return (
                <RoomRenderer
                  key={`${roomType}-${globalIndex}`}
                  roomType={roomType}
                  roomIndex={globalIndex}
                  config={config}
                  form={form}
                />
              );
            }),
          ),
        )}
      </>
    );
  }

  // Fall back to original behavior
  return (
    <>
      {times(quantity, (index) => (
        <RoomRenderer
          key={`${roomType}-${index}`}
          roomType={roomType}
          roomIndex={index}
          form={form}
          defaultGuests={getDefaultGuests(roomType)}
        />
      ))}
    </>
  );
};

export default RoomTypeSection;
